import ReactQuill, { Quill } from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const AlignStyle = Quill.import("attributors/style/align");
Quill.register(AlignStyle, true);

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }, { font: [] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["blockquote", "code-block"],
    ["link", "image"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "indent",
  "align",
  "blockquote",
  "code-block",
  "link",
  "image",
];

export const HtmlEmailEditor = ({ value, onChange }) => {
  const handleChange = (html, delta, source, editor) => {
    const containsImage = editor
      .getContents()
      .ops.some((operation) => operation.insert?.image);
    const hasContent = Boolean(editor.getText().trim()) || containsImage;
    onChange(hasContent ? html : "");
  };

  return (
    <div className="email-html-editor">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Write your email body"
      />
    </div>
  );
};
